import React, { useEffect } from 'react';
import { useState } from 'react';
import { User } from '../../../types/User';
import EnhancedTable from '../../Custom/Table';
import { getUsersAsAdmin } from '../../../api/users';
import { IGetUsersAsAdmin } from '../../../api/types';

interface UsersListProps {
  status: 'confirmed' | 'unconfirmed';
}

const UsersList: React.FC<UsersListProps> = ({ status }) => {
  const [usersList, setUsersList] = useState<User[] | []>([]);
  const [isLoading, setLoading] = useState<boolean>(true);
  const [searchedWord, setSearchedWord] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [usersRequest, setUsersRequest] = useState<IGetUsersAsAdmin | null>(
    null,
  );

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const resp: IGetUsersAsAdmin = await getUsersAsAdmin(
        currentPage,
        status,
        searchedWord,

      );
      setUsersRequest(resp);
    } catch (error) {
      console.error('Failed to fetch users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeUserStatus = (id: string) => {
    setUsersList(usersList.filter((x) => x.user_id !== id));
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchedWord(event.target.value);
  };

  useEffect(() => {
    setCurrentPage(1);
    setUsersList([]);
  }, [status]);


  useEffect(() => {
    fetchUsers();
  }, [searchedWord, currentPage, usersList]);

  return (
    <EnhancedTable
      setCurrentPage={setCurrentPage}
      usersRequest={usersRequest}
      setUsersList={setUsersList}
      searchedWord={searchedWord}
      setSearchedWord={setSearchedWord}
    />
  );
}
export default UsersList;